var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("default", function () {
        return [_c("div", [_vm._v("Название поля")])]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "myni" }, [
        _c(
          "div",
          {
            staticClass: "nights-field",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _setup.toggle.apply(null, arguments)
              },
            },
          },
          [
            _c(_setup.vDays, { staticClass: "ico-days vicon-black" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "label",
                class: { empty: _setup.days_text == _setup.props.placeholder },
              },
              [_vm._v(_vm._s(_setup.days_text))]
            ),
            _vm._v(" "),
            !_setup.isAny
              ? _c(
                  "button",
                  {
                    staticClass: "clear",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.setday(0, _setup.DAYS_MAX)
                      },
                    },
                  },
                  [_c(_setup.vRemove, { staticClass: "vicon-red" })],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _setup.isOpened
          ? _c("div", { ref: "oknoRef", staticClass: "nights-popup" }, [
              _c(
                "div",
                { staticClass: "nights-popup__content" },
                [
                  _vm._l(_setup.MANUAL, function ({ a, b, title }) {
                    return _c("label", { key: `${a}${b}`, staticClass: "g" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.manual_calc,
                            expression: "manual_calc",
                          },
                        ],
                        staticClass: "rb",
                        attrs: { name: "rb-manual", type: "radio" },
                        domProps: {
                          value: [a, b],
                          checked: _vm._q(_setup.manual_calc, [a, b]),
                        },
                        on: {
                          change: function ($event) {
                            _setup.manual_calc = [a, b]
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(title)),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "gcust" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.manual_calc,
                          expression: "manual_calc",
                        },
                      ],
                      staticClass: "rb",
                      attrs: { name: "rb-manual", type: "radio" },
                      domProps: {
                        value: _setup.MANUAL_CUST_AB,
                        checked: _vm._q(
                          _setup.manual_calc,
                          _setup.MANUAL_CUST_AB
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.manual_calc = _setup.MANUAL_CUST_AB
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "line" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.cust_a,
                              expression: "cust_a",
                            },
                          ],
                          staticClass: "sele sele0",
                          class: { red: !_setup.cust_valid() },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _setup.cust_a = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_setup.opt_cust0, function (option) {
                          return _c(
                            "option",
                            { domProps: { value: option.id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(option.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(
                        "\n\n                        -\n\n                        "
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.cust_b,
                              expression: "cust_b",
                            },
                          ],
                          staticClass: "sele sele1",
                          class: { red: !_setup.cust_valid() },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _setup.cust_b = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_setup.opt_cust1, function (option) {
                          return _c(
                            "option",
                            { domProps: { value: option.id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(option.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(
                        "\n\n                        дней\n                    "
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }